// src/pages/Landing.js
import { Link } from 'react-router-dom';
import Nav from '../components/Nav';

export default function Landing() {
  return (
    <div className="page">
      <Nav />

      {/* ── HERO ── */}
      <section style={{ background: '#fff', padding: '72px 0 64px', borderBottom: '1px solid var(--border)' }}>
        <div className="container">
          <div style={{ display: 'grid', gridTemplateColumns: '1fr auto', gap: 60, alignItems: 'center' }}>

            {/* LEFT — headline + CTA */}
            <div style={{ maxWidth: 580 }}>
              <div style={{ display: 'inline-flex', alignItems: 'center', gap: 8, background: '#eff6ff', border: '1px solid #bfdbfe', borderRadius: 999, padding: '5px 14px', marginBottom: 24 }}>
                <span style={{ width: 7, height: 7, background: '#10b981', borderRadius: '50%', display: 'inline-block' }}/>
                <span style={{ color: '#1e40af', fontSize: 13, fontWeight: 500 }}>14-day free trial · No credit card required</span>
              </div>
              <h1 style={{ fontFamily: 'var(--font-display)', fontWeight: 800, fontSize: 'clamp(32px,4.5vw,58px)', lineHeight: 1.08, color: 'var(--ink)', marginBottom: 12, letterSpacing: '-0.03em' }}>
                Turn Missed Calls Into<br/>Guaranteed Revenue.
              </h1>
              <h2 style={{ fontFamily: 'var(--font-display)', fontWeight: 500, fontSize: 'clamp(16px,2vw,20px)', lineHeight: 1.6, color: 'var(--muted)', marginBottom: 24, letterSpacing: '-0.01em' }}>
                While you operate your business, RingXai answers your phone, schedules clients, and captures every opportunity. No delays, no sick days—just pure, measurable growth.
              </h2>
              <p style={{ fontSize: 16, color: 'var(--muted)', lineHeight: 1.75, marginBottom: 32, maxWidth: 480 }}>
                RingXai answers every call 24/7 for your cleaning, HVAC, plumbing, or landscaping business — books the appointment, filters the spam, and hands you a live dashboard of every dollar it put in your pocket. Most owners cover the cost with a single recovered job.
              </p>
              <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', marginBottom: 24 }}>
                <Link to="/signup" className="btn btn-primary btn-lg">See what you're missing — free →</Link>
                <a href="tel:4358003116" className="btn btn-outline btn-lg">📞 Hear it answer a call</a>
              </div>
              <div style={{ display: 'flex', gap: 20, flexWrap: 'wrap' }}>
                {['Live in 10 minutes', 'Keep your number', 'Every booked job tracked'].map(t => (
                  <span key={t} style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 13, color: 'var(--muted)', fontWeight: 500 }}>
                    <span style={{ color: 'var(--green)', fontWeight: 700 }}>✓</span> {t}
                  </span>
                ))}
              </div>
            </div>

            {/* RIGHT — Try Me Now widget — pushed further right */}
            <div style={{ display: 'flex', justifyContent: 'flex-end', paddingLeft: 24 }}>
              <div style={{
                background: '#fff', border: '1.5px solid var(--border)',
                borderRadius: 20, padding: 28, maxWidth: 340, width: '100%',
                boxShadow: '0 20px 60px rgba(79,70,229,0.1)'
              }}>
                {/* Live indicator */}
                <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 20 }}>
                  <span style={{ width: 8, height: 8, background: 'var(--ring)', borderRadius: '50%', display: 'inline-block' }}/>
                  <span style={{ fontSize: 11, fontWeight: 700, color: 'var(--ring)', letterSpacing: '0.12em', textTransform: 'uppercase' }}>Try the live demo</span>
                </div>

                {/* Phone icon */}
                <div style={{ textAlign: 'center', marginBottom: 20 }}>
                  <div style={{
                    width: 72, height: 72, background: 'var(--ring-soft)',
                    borderRadius: '50%', display: 'flex', alignItems: 'center',
                    justifyContent: 'center', fontSize: 32, margin: '0 auto 16px',
                    border: '4px solid rgba(79,70,229,0.15)'
                  }}>📞</div>
                  <div style={{ fontFamily: 'var(--font-display)', fontSize: 22, fontWeight: 800, lineHeight: 1.2, color: 'var(--ink)', marginBottom: 4 }}>
                    Hear it live
                  </div>
                  <div style={{ fontFamily: 'var(--font-display)', fontSize: 18, fontWeight: 600, color: 'var(--muted)', fontStyle: 'italic', marginBottom: 16 }}>
                    right now.
                  </div>
                  <div style={{ fontFamily: 'var(--font-display)', fontWeight: 800, fontSize: 28, color: 'var(--ring)', letterSpacing: '-0.02em', marginBottom: 4 }}>
                    (435) 800-3116
                  </div>
                  <div style={{ fontSize: 12, color: 'var(--muted)', marginBottom: 20 }}>
                    This is our actual AI receptionist. Ask anything — book a demo, hear how it sounds, see what your callers will experience.
                  </div>
                </div>

                {/* CTA buttons */}
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
                  <a href="tel:4358003116" style={{
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    padding: '11px 0', borderRadius: 10, fontSize: 13, fontWeight: 600,
                    background: 'var(--surface)', border: '1px solid var(--border)',
                    color: 'var(--ink)', textDecoration: 'none', gap: 6
                  }}>📲 Tap to call</a>
                  <a href="tel:4358003116" style={{
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    padding: '11px 0', borderRadius: 10, fontSize: 13, fontWeight: 700,
                    background: 'var(--ring)', color: '#fff',
                    textDecoration: 'none', gap: 6
                  }}>Dial now →</a>
                </div>

                {/* Live dot */}
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6, marginTop: 16 }}>
                  <span style={{ width: 7, height: 7, background: 'var(--green)', borderRadius: '50%', display: 'inline-block', boxShadow: '0 0 6px #10b981' }}/>
                  <span style={{ fontSize: 12, color: 'var(--green)', fontWeight: 500 }}>Sophie is live and answering right now</span>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* ── TRUST BAR ── */}
      <section style={{ background: 'var(--surface)', borderBottom: '1px solid var(--border)', padding: '20px 0' }}>
        <div className="container">
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(140px,1fr))', gap: 0 }}>
            {[
              { n: '24/7', label: 'Always available' },
              { n: '<5s', label: 'Answers instantly' },
              { n: '100%', label: 'Calls answered' },
              { n: '15 min', label: 'To go live' },
              { n: '$0', label: 'Setup cost' },
            ].map((s, i) => (
              <div key={s.n} style={{ textAlign: 'center', padding: '12px 8px', borderRight: i < 4 ? '1px solid var(--border)' : 'none' }}>
                <div style={{ fontFamily: 'var(--font-display)', fontWeight: 800, fontSize: 22, color: 'var(--ring)' }}>{s.n}</div>
                <div style={{ fontSize: 12, color: 'var(--muted)', marginTop: 2 }}>{s.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── LIVE DEMO ── */}
      <section style={{ background: '#fff', padding: '72px 0', borderBottom: '1px solid var(--border)' }}>
        <div className="container" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(280px,1fr))', gap: 48, alignItems: 'center' }}>
          <div>
            <p style={{ fontSize: 12, fontWeight: 700, color: 'var(--ring)', letterSpacing: '0.12em', textTransform: 'uppercase', marginBottom: 12 }}>Try it right now</p>
            <h2 style={{ fontFamily: 'var(--font-display)', fontSize: 'clamp(26px,3.5vw,40px)', fontWeight: 800, marginBottom: 16, letterSpacing: '-0.02em' }}>
              Call Sophie.<br/>Hear exactly what<br/>your customers will.
            </h2>
            <p style={{ fontSize: 16, color: 'var(--muted)', lineHeight: 1.7 }}>
              This is our actual AI receptionist. Call her right now — ask about booking a job, check availability, hear how she handles a real customer. No demo video. The real thing.
            </p>
          </div>
          <div>
            <div style={{ background: '#fff', border: '2px solid var(--ring)', borderRadius: 20, padding: 28, maxWidth: 340 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 16 }}>
                <div style={{ width: 48, height: 48, background: 'var(--ring-soft)', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 22 }}>📞</div>
                <div>
                  <div style={{ fontSize: 11, fontWeight: 600, color: 'var(--muted)', letterSpacing: '0.08em', textTransform: 'uppercase' }}>Live demo — call now</div>
                  <div style={{ fontFamily: 'var(--font-display)', fontSize: 22, fontWeight: 800, color: 'var(--ring)' }}>(435) 800-3116</div>
                </div>
              </div>
              <div style={{ background: 'var(--surface)', borderRadius: 10, padding: '12px 16px', marginBottom: 16, fontSize: 13, color: 'var(--muted)', lineHeight: 1.6 }}>
                This is our actual Sophie agent. Ask her to book a cleaning, HVAC job, or anything your business offers. Experience it before you sign up.
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <span style={{ width: 8, height: 8, background: 'var(--green)', borderRadius: '50%', display: 'inline-block', boxShadow: '0 0 6px #10b981' }}/>
                <span style={{ fontSize: 13, color: 'var(--green)', fontWeight: 500 }}>Sophie is live and answering right now</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── 3 BAD OPTIONS ── */}
      <section style={{ background: 'var(--surface)', padding: '72px 0', borderBottom: '1px solid var(--border)' }}>
        <div className="container" style={{ textAlign: 'center' }}>
          <p style={{ fontSize: 12, fontWeight: 700, color: 'var(--red)', letterSpacing: '0.12em', textTransform: 'uppercase', marginBottom: 12 }}>The problem</p>
          <h2 style={{ fontFamily: 'var(--font-display)', fontSize: 'clamp(26px,3.5vw,40px)', fontWeight: 800, marginBottom: 12, letterSpacing: '-0.02em' }}>
            You currently have 3 bad options<br/>for handling incoming calls
          </h2>
          <p style={{ fontSize: 16, color: 'var(--muted)', maxWidth: 480, margin: '0 auto 40px' }}>Every option costs you money, time, or customers. Until now.</p>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(240px,1fr))', gap: 20, marginBottom: 40 }}>
            {[
              { title: 'Answer every call yourself', items: ['Constant interruptions all day', 'Wasted time on spam calls', 'Impossible after business hours'] },
              { title: 'Send calls to voicemail', items: ['80% of callers never leave a message', 'Hard to call back in time', 'Callers go straight to competitors'] },
              { title: 'Pay for an answering service', items: ['$2+ per minute, every call', 'Inconsistent quality and training', 'Long hold times frustrate callers'] },
            ].map(c => (
              <div key={c.title} style={{ background: '#fff', border: '1px solid #fecaca', borderRadius: 16, padding: 24, textAlign: 'left' }}>
                <div style={{ width: 32, height: 32, background: '#fef2f2', border: '1px solid #fecaca', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 16, marginBottom: 12 }}>✕</div>
                <div style={{ fontFamily: 'var(--font-display)', fontWeight: 700, fontSize: 16, color: '#991b1b', marginBottom: 12 }}>{c.title}</div>
                {c.items.map(item => (
                  <div key={item} style={{ display: 'flex', gap: 8, alignItems: 'flex-start', fontSize: 13, color: '#7f1d1d', marginBottom: 6 }}>
                    <span style={{ color: '#ef4444', marginTop: 2 }}>✕</span> {item}
                  </div>
                ))}
              </div>
            ))}
          </div>
          <div style={{ display: 'inline-flex', alignItems: 'center', gap: 10, background: 'var(--ring-soft)', border: '1px solid #c7d2fe', borderRadius: 12, padding: '14px 24px' }}>
            <span style={{ fontSize: 20 }}>💡</span>
            <span style={{ fontFamily: 'var(--font-display)', fontWeight: 700, fontSize: 17, color: 'var(--ring)' }}>There is a fourth option. Meet RingXai.</span>
          </div>
        </div>
      </section>

      {/* ── WHAT RingXai DOES ── */}
      <section id="features" style={{ background: '#fff', padding: '72px 0', borderBottom: '1px solid var(--border)' }}>
        <div className="container" style={{ textAlign: 'center' }}>
          <p style={{ fontSize: 12, fontWeight: 700, color: 'var(--green)', letterSpacing: '0.12em', textTransform: 'uppercase', marginBottom: 12 }}>What RingXai does</p>
          <h2 style={{ fontFamily: 'var(--font-display)', fontSize: 'clamp(26px,3.5vw,40px)', fontWeight: 800, marginBottom: 12, letterSpacing: '-0.02em' }}>
            Everything your front desk needs.<br/>None of the overhead.
          </h2>
          <p style={{ fontSize: 16, color: 'var(--muted)', maxWidth: 480, margin: '0 auto 40px', lineHeight: 1.7 }}>
            Sophie answers every call in under 5 seconds, 24 hours a day. She sounds human, books jobs, and updates automatically when you change your settings.
          </p>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(220px,1fr))', gap: 16 }}>
            {[
              { icon: '📞', title: 'Answers every call', desc: 'No more voicemail. Sophie picks up in seconds, greets callers by your business name, and handles the conversation.' },
              { icon: '📅', title: 'Books appointments', desc: 'Callers give their details, pick a service, and get booked — all without you lifting a finger.' },
              { icon: '💬', title: 'English & Spanish', desc: 'Sophie detects the caller\'s language and switches automatically. Serve every customer, no extra cost.' },
              { icon: '🌙', title: 'After hours coverage', desc: 'Sophie answers at 2am, on weekends, on holidays. You never miss a booking again.' },
              { icon: '📊', title: 'ROI dashboard', desc: 'See exactly how many calls Sophie answered and how much revenue she captured for your business.' },
              { icon: '🔄', title: 'Instant call transfer', desc: 'When a caller needs a human, Sophie transfers them to your phone instantly — no caller left behind.' },
            ].map(f => (
              <div key={f.title} style={{ background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 16, padding: 24, textAlign: 'left' }}>
                <div style={{ fontSize: 28, marginBottom: 12 }}>{f.icon}</div>
                <div style={{ fontFamily: 'var(--font-display)', fontWeight: 700, fontSize: 15, marginBottom: 8 }}>{f.title}</div>
                <div style={{ fontSize: 13, color: 'var(--muted)', lineHeight: 1.7 }}>{f.desc}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── DASHBOARD PREVIEW ── */}
      <section style={{ background: 'var(--ink)', padding: '72px 0', borderBottom: '1px solid rgba(255,255,255,0.1)' }}>
        <div className="container" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(280px,1fr))', gap: 48, alignItems: 'center' }}>
          <div>
            <p style={{ fontSize: 12, fontWeight: 700, color: '#818cf8', letterSpacing: '0.12em', textTransform: 'uppercase', marginBottom: 12 }}>Your dashboard</p>
            <h2 style={{ fontFamily: 'var(--font-display)', fontSize: 'clamp(26px,3.5vw,40px)', fontWeight: 800, color: '#fff', marginBottom: 16, letterSpacing: '-0.02em' }}>
              See exactly how much<br/>Sophie is making you
            </h2>
            <p style={{ fontSize: 16, color: 'rgba(255,255,255,0.6)', lineHeight: 1.7, marginBottom: 24 }}>
              Every morning, log in and see your calls answered, bookings made, and estimated revenue captured — all in one place.
            </p>
            {['Calls answered this month', 'Estimated revenue generated', 'ROI vs plan cost', 'Full booking history'].map(item => (
              <div key={item} style={{ display: 'flex', gap: 10, alignItems: 'center', fontSize: 14, color: 'rgba(255,255,255,0.8)', marginBottom: 10 }}>
                <span style={{ color: '#10b981', fontWeight: 700 }}>✓</span> {item}
              </div>
            ))}
          </div>
          <div>
            <div style={{ background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: 16, padding: 20 }}>
              <div style={{ fontSize: 13, color: 'rgba(255,255,255,0.4)', marginBottom: 16, fontWeight: 500 }}>This month — Avengers Cleaning Services</div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, marginBottom: 16 }}>
                {[
                  { label: 'Calls answered', value: '42', color: '#818cf8' },
                  { label: 'Bookings made', value: '31', color: '#34d399' },
                  { label: 'Est. revenue', value: '$5,890', color: '#34d399' },
                  { label: 'Plan cost', value: '$99', color: 'rgba(255,255,255,0.6)' },
                ].map(s => (
                  <div key={s.label} style={{ background: 'rgba(255,255,255,0.06)', borderRadius: 10, padding: 14 }}>
                    <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.4)', marginBottom: 4 }}>{s.label}</div>
                    <div style={{ fontFamily: 'var(--font-display)', fontWeight: 800, fontSize: 22, color: s.color }}>{s.value}</div>
                  </div>
                ))}
              </div>
              <div style={{ background: 'rgba(16,185,129,0.15)', border: '1px solid rgba(16,185,129,0.3)', borderRadius: 10, padding: '12px 16px' }}>
                <div style={{ fontSize: 12, color: '#34d399', fontWeight: 600 }}>💰 Sophie generated an estimated $5,890 this month</div>
                <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.5)', marginTop: 4 }}>vs. $99/mo plan cost — that's a 5,849% return</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── THE MATH ── */}
      <section style={{ background: 'linear-gradient(135deg,#ecfdf5,#eff6ff)', padding: '72px 0', borderBottom: '1px solid var(--border)' }}>
        <div className="container" style={{ textAlign: 'center' }}>
          <p style={{ fontSize: 12, fontWeight: 700, color: 'var(--green)', letterSpacing: '0.12em', textTransform: 'uppercase', marginBottom: 12 }}>The math</p>
          <h2 style={{ fontFamily: 'var(--font-display)', fontSize: 'clamp(26px,3.5vw,40px)', fontWeight: 800, marginBottom: 12, letterSpacing: '-0.02em' }}>
            Sophie pays for herself<br/>on the first call
          </h2>
          <p style={{ fontSize: 16, color: 'var(--muted)', maxWidth: 440, margin: '0 auto 40px', lineHeight: 1.7 }}>
            Most service businesses get 30–60 calls a month. One booked job covers the entire cost of RingXai.
          </p>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(180px,1fr))', gap: 16, maxWidth: 860, margin: '0 auto 32px' }}>
            {[
              { label: 'Avg calls per month', value: '40', sub: 'typical service business' },
              { label: 'Avg job value', value: '$185', sub: 'cleaning, HVAC, plumbing...' },
              { label: 'Calls Sophie captures', value: '100%', sub: 'vs ~40% without AI' },
              { label: 'Est. monthly revenue', value: '$7,400', sub: 'potential from Sophie' },
            ].map(m => (
              <div key={m.label} style={{ background: '#fff', border: '1px solid var(--border)', borderRadius: 14, padding: 20 }}>
                <div style={{ fontFamily: 'var(--font-display)', fontWeight: 800, fontSize: 30, color: 'var(--ink)', marginBottom: 4 }}>{m.value}</div>
                <div style={{ fontSize: 12, fontWeight: 600, color: 'var(--ink-2)', marginBottom: 4 }}>{m.label}</div>
                <div style={{ fontSize: 11, color: 'var(--muted)' }}>{m.sub}</div>
              </div>
            ))}
          </div>
          <div style={{ display: 'inline-flex', alignItems: 'center', gap: 14, background: '#fff', border: '2px solid var(--green)', borderRadius: 14, padding: '16px 28px' }}>
            <span style={{ fontSize: 24 }}>💰</span>
            <div style={{ textAlign: 'left' }}>
              <div style={{ fontFamily: 'var(--font-display)', fontWeight: 800, fontSize: 18, color: 'var(--ink)' }}>Plans start at just $49/month</div>
              <div style={{ fontSize: 13, color: 'var(--muted)' }}>One booked job covers it. Everything else is pure profit.</div>
            </div>
          </div>
        </div>
      </section>

      {/* ── HOW IT WORKS ── */}
      <section style={{ background: '#fff', padding: '72px 0', borderBottom: '1px solid var(--border)' }}>
        <div className="container">
          <div style={{ textAlign: 'center', marginBottom: 48 }}>
            <p style={{ fontSize: 12, fontWeight: 700, color: 'var(--ring)', letterSpacing: '0.12em', textTransform: 'uppercase', marginBottom: 12 }}>How it works</p>
            <h2 style={{ fontFamily: 'var(--font-display)', fontSize: 'clamp(26px,3.5vw,40px)', fontWeight: 800, letterSpacing: '-0.02em' }}>Up and running in 20 minutes</h2>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(220px,1fr))', gap: 0 }}>
            {[
              { n: '01', title: 'Sign up free', desc: 'Create your account and fill in your business name, hours, services, and pricing. Takes about 5 minutes.' },
              { n: '02', title: 'Sophie goes live', desc: 'Forward your business number to Sophie. She starts answering calls within 15 minutes of setup.' },
              { n: '03', title: 'Watch the ROI', desc: 'Every call Sophie answers shows on your dashboard — with an estimate of the revenue she captured.' },
            ].map((s, i) => (
              <div key={s.n} style={{ padding: '36px 32px', borderRight: i < 2 ? '1px solid var(--border)' : 'none' }}>
                <div style={{ fontFamily: 'var(--font-display)', fontSize: 56, fontWeight: 800, color: 'var(--border)', lineHeight: 1, marginBottom: 16 }}>{s.n}</div>
                <h3 style={{ fontFamily: 'var(--font-display)', fontSize: 18, fontWeight: 700, marginBottom: 8 }}>{s.title}</h3>
                <p style={{ fontSize: 14, color: 'var(--muted)', lineHeight: 1.7 }}>{s.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── TESTIMONIALS ── */}
      <section id="partners" style={{ background: 'var(--surface)', padding: '72px 0', borderBottom: '1px solid var(--border)' }}>
        <div className="container" style={{ textAlign: 'center' }}>
          <p style={{ fontSize: 12, fontWeight: 700, color: 'var(--ring)', letterSpacing: '0.12em', textTransform: 'uppercase', marginBottom: 12 }}>What clients say</p>
          <h2 style={{ fontFamily: 'var(--font-display)', fontSize: 'clamp(26px,3.5vw,40px)', fontWeight: 800, marginBottom: 40, letterSpacing: '-0.02em' }}>Real businesses. Real results.</h2>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(260px,1fr))', gap: 20 }}>
            {[
              { quote: 'I used to miss 10-15 calls a week while I was on jobs. Since RingXai, every call gets answered. I booked 8 new clients in my first month.', name: 'Maria R.', biz: 'Residential Cleaning, Houston TX', stars: 5 },
              { quote: "My HVAC business runs on referrals and callbacks. Sophie handles every inquiry professionally and transfers the urgent ones straight to me. Worth every penny.", name: 'James T.', biz: 'HVAC Services, Dallas TX', stars: 5 },
              { quote: "I was skeptical about AI but tried it anyway. Sophie sounds completely natural. My customers don't even realize they're talking to AI. Bookings are up 40%.", name: 'Carlos M.', biz: 'Landscaping Co., San Antonio TX', stars: 5 },
            ].map(t => (
              <div key={t.name} style={{ background: '#fff', border: '1px solid var(--border)', borderRadius: 16, padding: 24, textAlign: 'left' }}>
                <div style={{ color: '#f59e0b', fontSize: 16, marginBottom: 14 }}>{'★'.repeat(t.stars)}</div>
                <p style={{ fontSize: 14, color: 'var(--ink-2)', lineHeight: 1.75, marginBottom: 16, fontStyle: 'italic' }}>"{t.quote}"</p>
                <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                  <div style={{ width: 36, height: 36, background: 'var(--ring-soft)', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'var(--font-display)', fontWeight: 700, fontSize: 14, color: 'var(--ring)' }}>
                    {t.name.charAt(0)}
                  </div>
                  <div>
                    <div style={{ fontWeight: 600, fontSize: 14, color: 'var(--ink)' }}>{t.name}</div>
                    <div style={{ fontSize: 12, color: 'var(--muted)' }}>{t.biz}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── PRICING ── */}
      <section id="pricing" style={{ background: '#fff', padding: '72px 0', borderBottom: '1px solid var(--border)' }}>
        <div className="container" style={{ textAlign: 'center' }}>
          <p style={{ fontSize: 12, fontWeight: 700, color: 'var(--ring)', letterSpacing: '0.12em', textTransform: 'uppercase', marginBottom: 12 }}>Pricing</p>
          <h2 style={{ fontFamily: 'var(--font-display)', fontSize: 'clamp(26px,3.5vw,40px)', fontWeight: 800, marginBottom: 12, letterSpacing: '-0.02em' }}>Simple plans. No surprises.</h2>
          <p style={{ fontSize: 16, color: 'var(--muted)', marginBottom: 40 }}>Start free for 14 days. No credit card required.</p>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(210px,1fr))', gap: 20, maxWidth: 1100, margin: '0 auto' }}>
            {[
              {
                name: 'Starter', price: '$49', period: '/mo',
                desc: 'Perfect for solo operators just getting started',
                badge: null, highlight: false,
                features: ['24/7 call answering', 'Appointment booking', 'Transfer to your number', 'Call log — phone & duration', 'Basic ROI dashboard', 'English & Spanish'],
                cta: 'Start free trial', ctaLink: true,
              },
              {
                name: 'Pro', price: '$99', period: '/mo',
                desc: 'For growing businesses that need full visibility',
                badge: 'Most popular', highlight: true,
                features: ['Everything in Starter', 'Full call transcripts', 'Call summaries after each call', 'SMS booking confirmations', 'Advanced ROI dashboard', 'Priority activation'],
                cta: 'Start free trial', ctaLink: true,
              },
              {
                name: 'Premium', price: '$149', period: '/mo',
                desc: 'For established businesses ready to scale',
                badge: null, highlight: false,
                features: ['Everything in Pro', 'Multiple locations', 'Custom AI instructions', 'Dedicated onboarding support', 'Fastest agent updates', 'Early access to new features'],
                cta: 'Start free trial', ctaLink: true,
              },
              {
                name: 'Custom', price: 'Custom', period: '',
                desc: 'For agencies, franchises, and multi-location businesses',
                badge: 'Best for agencies', highlight: false,
                features: ['Everything in Premium', 'Unlimited locations', 'White-label option', 'Custom integrations built for you', 'Dedicated account manager', 'Volume pricing discounts'],
                cta: 'Contact us', ctaLink: false,
              },
            ].map((plan, i) => (
              <div key={plan.name} style={{
                background: '#fff',
                border: plan.highlight ? '2px solid var(--ring)' : plan.name === 'Custom' ? '1.5px solid var(--ink-2)' : '1px solid var(--border)',
                borderRadius: 18, padding: 28, textAlign: 'left', position: 'relative'
              }}>
                {plan.badge && (
                  <div style={{ position: 'absolute', top: -13, left: '50%', transform: 'translateX(-50%)', background: plan.name === 'Custom' ? 'var(--ink-2)' : 'var(--ring)', color: '#fff', fontSize: 12, fontWeight: 600, padding: '4px 14px', borderRadius: 999, whiteSpace: 'nowrap' }}>
                    {plan.badge}
                  </div>
                )}
                <div style={{ marginBottom: 8 }}>
                  <span style={{ fontFamily: 'var(--font-display)', fontWeight: 700, fontSize: 15, color: 'var(--ink)' }}>{plan.name}</span>
                </div>
                <div style={{ marginBottom: 8 }}>
                  <span style={{ fontFamily: 'var(--font-display)', fontWeight: 800, fontSize: plan.price === 'Custom' ? 28 : 36, color: plan.price === 'Custom' ? 'var(--ink-2)' : 'var(--ink)' }}>{plan.price}</span>
                  <span style={{ fontSize: 14, color: 'var(--muted)' }}>{plan.period}</span>
                </div>
                <p style={{ fontSize: 13, color: 'var(--muted)', marginBottom: 20, lineHeight: 1.5 }}>{plan.desc}</p>
                <div style={{ borderTop: '1px solid var(--border)', paddingTop: 16, marginBottom: 20 }}>
                  {plan.features.map(f => (
                    <div key={f} style={{ display: 'flex', gap: 8, alignItems: 'flex-start', fontSize: 13, color: 'var(--ink-2)', marginBottom: 8 }}>
                      <span style={{ color: 'var(--green)', fontWeight: 700, marginTop: 1 }}>✓</span> {f}
                    </div>
                  ))}
                </div>
                {plan.ctaLink
                  ? <Link to="/signup" className={`btn ${plan.highlight ? 'btn-primary' : 'btn-outline'}`} style={{ width: '100%', justifyContent: 'center' }}>{plan.cta}</Link>
                  : <a href="mailto:hello@ringxai.com" className="btn btn-ghost" style={{ width: '100%', justifyContent: 'center', border: '1.5px solid var(--ink-2)', color: 'var(--ink-2)' }}>{plan.cta} →</a>
                }
              </div>
            ))}
          </div>
          <p style={{ fontSize: 13, color: 'var(--muted)', marginTop: 20 }}>All plans include a 14-day free trial. No contracts. Cancel anytime.</p>
        </div>
      </section>

      {/* ── WHO IT'S FOR ── */}
      <section style={{ background: 'var(--surface)', padding: '72px 0', borderBottom: '1px solid var(--border)', textAlign: 'center' }}>
        <div className="container">
          <p style={{ fontSize: 12, fontWeight: 700, color: 'var(--ring)', letterSpacing: '0.12em', textTransform: 'uppercase', marginBottom: 12 }}>Built for</p>
          <h2 style={{ fontFamily: 'var(--font-display)', fontSize: 'clamp(26px,3.5vw,40px)', fontWeight: 800, marginBottom: 32, letterSpacing: '-0.02em' }}>Any business that takes calls</h2>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10, justifyContent: 'center' }}>
            {['🧹 Cleaning', '🔧 HVAC', '🪠 Plumbing', '🌿 Landscaping', '💇 Salon & Beauty', '🏠 Property Mgmt', '🐾 Pet Services', '⚡ Electrical', '🚗 Auto Repair', '🦷 Dental', '🏗 Construction', '📦 Moving Services'].map(b => (
              <div key={b} style={{ background: '#fff', border: '1px solid var(--border)', borderRadius: 999, padding: '9px 18px', fontSize: 14, fontWeight: 500, color: 'var(--ink-2)' }}>{b}</div>
            ))}
          </div>
        </div>
      </section>

      {/* ── FAQ ── */}
      <section style={{ background: '#fff', padding: '72px 0', borderBottom: '1px solid var(--border)' }}>
        <div className="container">
          <div style={{ textAlign: 'center', marginBottom: 48 }}>
            <p style={{ fontSize: 12, fontWeight: 700, color: 'var(--ring)', letterSpacing: '0.12em', textTransform: 'uppercase', marginBottom: 12 }}>Questions</p>
            <h2 style={{ fontFamily: 'var(--font-display)', fontSize: 'clamp(26px,3.5vw,40px)', fontWeight: 800, letterSpacing: '-0.02em' }}>Frequently asked</h2>
          </div>
          <div style={{ maxWidth: 640, margin: '0 auto' }}>
            {[
              { q: 'Do I need to change my phone number?', a: 'No. You keep your existing number and simply forward calls to Sophie. Setup takes about 2 minutes and your customers will never notice the difference.' },
              { q: 'What if Sophie can\'t answer a question?', a: 'Sophie transfers the call directly to your phone so you can handle it. Nothing falls through the cracks — callers always get a real resolution.' },
              { q: 'How long does it take to get set up?', a: 'Most businesses are fully live within 20 minutes. Sign up, fill in your business details, forward your number — Sophie starts answering immediately.' },
              { q: 'Does Sophie work after hours and on weekends?', a: 'Yes. Sophie answers 24 hours a day, 7 days a week, 365 days a year — including holidays. She never takes a day off.' },
              { q: 'Can I update Sophie\'s settings after I set up?', a: 'Yes, anytime. Log into your RingXai portal, update your hours, services, or pricing, and Sophie automatically updates within 15 minutes.' },
              { q: 'What if I want to cancel?', a: 'No contracts, no cancellation fees. Cancel anytime from your dashboard in one click. We\'re confident you\'ll stay once you see the results.' },
            ].map((faq, i) => (
              <div key={i} style={{ borderBottom: '1px solid var(--border)', padding: '20px 0' }}>
                <div style={{ fontFamily: 'var(--font-display)', fontWeight: 700, fontSize: 16, color: 'var(--ink)', marginBottom: 8 }}>{faq.q}</div>
                <div style={{ fontSize: 14, color: 'var(--muted)', lineHeight: 1.75 }}>{faq.a}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── FINAL CTA ── */}
      <section style={{ background: 'linear-gradient(135deg,#0a0a0f,#1a1a2e)', padding: '80px 0', textAlign: 'center' }}>
        <div className="container">
          <h2 style={{ fontFamily: 'var(--font-display)', fontSize: 'clamp(28px,4vw,48px)', fontWeight: 800, color: '#fff', marginBottom: 16, letterSpacing: '-0.02em' }}>
            Stop losing calls.<br/>Start with RingXai today.
          </h2>
          <p style={{ fontSize: 18, color: 'rgba(255,255,255,0.55)', marginBottom: 36 }}>14 days free. No credit card. Cancel anytime.</p>
          <Link to="/signup" className="btn btn-primary btn-lg" style={{ background: 'var(--ring)', boxShadow: '0 8px 40px rgba(79,70,229,0.5)' }}>
            Get started free →
          </Link>
          <p style={{ marginTop: 20, fontSize: 13, color: 'rgba(255,255,255,0.3)' }}>
            Setup in 20 minutes · Keep your number · English & Spanish · No contracts
          </p>
        </div>
      </section>

      {/* ── FOOTER ── */}
      <footer style={{ background: '#070710', padding: '32px 0' }}>
        <div className="container" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 16 }}>
          <div style={{ fontFamily: 'var(--font-display)', fontSize: 20, fontWeight: 800, color: '#fff' }}>
            Ring<span style={{ color: '#818cf8' }}>Xai</span>
          </div>
          <p style={{ color: 'rgba(255,255,255,0.2)', fontSize: 13 }}>© 2026 RingXai. All rights reserved.</p>
          <div style={{ display: 'flex', gap: 20 }}>
            <Link to="/login" style={{ color: 'rgba(255,255,255,0.3)', fontSize: 13, textDecoration: 'none' }}>Log in</Link>
            <Link to="/signup" style={{ color: 'rgba(255,255,255,0.3)', fontSize: 13, textDecoration: 'none' }}>Sign up</Link>
          </div>
        </div>
      </footer>
    </div>
  );
}
